import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

const routeslist = [
  {
    path: '/',
    redirect: '/loading'
  },
  // 落地页
  {
    path: '/loading',
    name: 'loading',
    component: () => import('../views/loading/loading.vue'),
    meta: {
      title: 'loading'
    }
  },
  // 自建关卡页
  {
    path: '/selfbuilt',
    name: 'selfbuilt',
    component: () => import('../views/selfbuilt/selfbuilt.vue'),
    meta: {
      title: '创建关卡'
    }
  },
  // 编辑关卡页
  {
    path: '/editbuilt',
    name: 'editbuilt',
    component: () => import('../views/editbuilt/editbuilt.vue'),
    meta: {
      title: '编辑关卡'
    }
  },
  // 海报
  {
    path: '/poster',
    name: 'poster',
    component: () => import('../views/posters/poster.vue'),
    meta: {
      title: '海报',
      keepAlive: true
    }
  },
  // 闯关
  {
    path: '/challenge',
    name: 'challenge',
    component: () => import('../views/challenge/challenge.vue'),
    meta: {
      title: '闯关'
    }
  },
  // 我的关卡列表
  {
    path: '/levellist',
    name: 'levellist',
    component: () => import('../views/levellist/levellist.vue'),
    meta: {
      title: '闯关'
    }
  },
  // 排行榜
  {
    path: '/ranking',
    name: 'ranking',
    component: () => import('../views/ranking/ranking.vue'),
    meta: {
      title: '闯关'
    }
  },
  // 草稿列表
  {
    path: '/draftlist',
    name: 'draftlist',
    component: () => import('../views/draftlist/draftlist.vue'),
    meta: {
      title: '闯关'
    }
  },
  // 举报
  {
    path: '/report',
    name: 'report',
    component: () => import('../views/report/report.vue'),
    meta: {
      title: '举报'
    }
  },
  // 隐私政策
  {
    path: '/privacytreaty',
    name: 'privacytreaty',
    component: () => import('../views/privacy/privacy.vue'),
    meta: {
      title: '隐私政策'
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/privacytreaty/privacytreaty.vue'),
    meta: {
      title: '隐私政策'
    }
  },
  // 用户协议
  {
    path: '/usertreaty',
    name: 'usertreaty',
    component: () => import('../views/useragreement/useragreement.vue'),
    meta: {
      title: '用户协议'
    }
  },
  {
    path: '/useragreement',
    name: 'useragreement',
    component: () => import('../views/usertreaty/usertreaty.vue'),
    meta: {
      title: '用户协议'
    }
  },
   // 第三方协议
  {
    path: '/thirdtreaty',
    name: 'thirdtreaty',
    component: () => import('../views/thirdparty/thirdparty.vue'),
    meta: {
      title: '第三方协议'
    }
  },
  {
    path: '/thirdparty',
    name: 'thirdparty',
    component: () => import('../views/thirdtreaty/thirdtreaty.vue'),
    meta: {
      title: '第三方协议'
    }
  },
  // 支付协议
  {
    path: '/payment',
    name: 'payment',
    component: () => import('../views/payment/payment.vue'),
    meta: {
      title: '支付协议'
    }
  },
  {
    path: '/paymenttreaty',
    name: 'paymenttreaty',
    component: () => import('../views/paymenttreaty/paymenttreaty.vue'),
    meta: {
      title: '支付协议'
    }
  },
  // 创建NPC
  {
    path: '/draw',
    name: 'draw',
    component: () => import('../views/draw/draw.vue'),
    meta: {
      title: '创建NPC'
    }
  },
  // 说明页
  {
    path: '/describe',
    name: 'describe',
    component: () => import('../views/describe/describe.vue'),
    meta: {
      title: '成就说明页'
    }
  },
  // 首页
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/home/home.vue'),
    meta: {
      title: '首页'
    }
  },
  // qustion 亲密度
  {
    path: '/qustion',
    name: 'qustion',
    component: () => import('../views/qustion/qustion.vue'),
    meta: {
      title: 'ABTI答题'
    }
  },
  // 亲密度
  {
    path: '/intimacy',
    name: 'intimacy',
    component: () => import('../views/intimacy/intimacy.vue'),
    meta: {
      title: '亲密度攻略'
    }
  },
  // 广告
  {
    path: '/infomercial',
    name: 'infomercial',
    component: () => import('../views/infomercial/infomercial.vue'),
    meta: {
      title: '广告海报'
    }
  }
];

// 路由初始化配置
const createRouter = () =>
  new Router({
    mode: 'history',
    base: 'm-chatbird',
    scrollBehavior: (to, from, savedPosition) => {
      console.log(savedPosition,'kdkdkdkk')
      if (savedPosition) {
        // 返回到之前的滚动位置
        return savedPosition;
      } else {
        // 新页面滚动到顶部
        return { x: 0, y: 0 };
      }
    },
    routes: [...routeslist]
  });

const router = createRouter();

// 重载路由
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

// 导航守卫，渲染动态路由
router.beforeEach((to, from, next) => {
  document.title = 'ChatBird';
  next();
});

export default router;
